import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { ApolloResponse } from '@/interfaces/apollo'
import { RecordType, RecordTypeAdditionalInfo, RecordTypeFormItem, RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import { RadioDoubleLine } from '@/interfaces/radio-double-line'
import { showErrors } from '@/utils/snack'
import { getRecordTypes } from '@/modules/RecordType/gql/record-type.gql'
import { dispatchUpdateRecordTypes } from '@/store/dispatches'
import { splitStringToArray } from '@/utils/split_string_to_array'

@Component
export default class RecordTypesHandler extends Vue {
  recordTypes: RecordType[] = []
  recentlyUsedRecordTypes: RecordType[] = []

  additionalInput: { [key: string]: any; } = {}

  recordTypesOptions: { [key: string]: RadioDoubleLine[] } = {}

  candidateRecordTypes: RecordType[] = []

  get candidatesRecordTypeOptions () {
    return this.candidateRecordTypes.map(rt => {
      return {
        id: +rt.id,
        name: rt.name
      }
    })
  }

  @State(state => state.recordType.recordTypes) allRecordTypes!: RecordType[]

  async getRecordTypes (type: string) {
    if (this.$R.isEmpty(this.allRecordTypes)) {
      await this.getAllRecordTypes()
    }
    this.recordTypes = this.allRecordTypes.filter((rt) => {
      return rt.master === type
    })

    const recordTypesOptionsCopy = JSON.parse(JSON.stringify(this.recordTypesOptions))

    recordTypesOptionsCopy[type] = []

    this.recordTypes.map((recordType: RecordType) => {
      this.additionalInput[recordType.name] = {}
      const { additionalInfo } = recordType

      recordTypesOptionsCopy[type].push({
        title: recordType.name,
        subTitle: recordType.description
      })

      additionalInfo.map((info: RecordTypeAdditionalInfo) => {
        const { items } = info
        if (info.title === 'Base') {
          return
        }
        if (items) {
          items.map((item: RecordTypeFormItem) => {
            if (item.keyName) {
              this.additionalInput[recordType.name][item.keyName] = ''
            }
          })
        }
      })
    })

    this.recordTypesOptions = JSON.parse(JSON.stringify(recordTypesOptionsCopy))
    // sort改变了原来数组，导致数组和选项对不上
    const recordTypesCopy:RecordType[] = JSON.parse(JSON.stringify(this.recordTypes))
    const sortedByUsedTimes = recordTypesCopy.sort((a, b) => {
      return b.usedTimes - a.usedTimes
    })

    this.recentlyUsedRecordTypes = sortedByUsedTimes.slice(0, 10)
  }

  getCandidateRecordTypes (val: string) {
    const recordTypes = this.recordTypes.filter((rt: RecordType) => {
      const words = splitStringToArray(val)
      for (const word of words) {
        if (rt.name.toLowerCase().indexOf(word.toLocaleLowerCase()) === -1) {
          return false
        }
      }
      return true
    })
    this.candidateRecordTypes = recordTypes
  }

  async getAllRecordTypes () {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getRecordTypes,
        variables: {
          masterType: null,
          orderBy: {
            orderBy: 'NAME',
            asc: true
          },
          paging: {
            offset: 0,
            limit: 1000
          }
        }
      })
      const { recordTypes } = result.data.getRecordTypes
      dispatchUpdateRecordTypes(recordTypes)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
